// Shared storefront ordering + brand detection. Written as CommonJS (like
// slug.js) so StorePage, the browser cache (installCache.js) and Node scripts
// all use identical logic. backend/server.py mirrors CATEGORY_RANK for
// sort=featured and brandOf() for the ?brand= filter - keep them in sync.

// "All Products" order: hybrid inverters, on-grid / off-grid, micro inverters,
// batteries, energy storage systems, then everything else. Cheapest first
// inside each group; brands are mixed fairly.
const CATEGORY_RANK = {
  "Hybrid Inverter": 0,
  "On Grid Inverter": 1,
  "Off Grid Inverter": 1,
  "Micro Inverter": 2,
  "Battery": 3,
  "Energy Storage System": 4,
};
const OTHER_RANK = 5;

function featuredRank(p) {
  const r = CATEGORY_RANK[p && p.category];
  return r === undefined ? OTHER_RANK : r;
}

function featuredCompare(a, b) {
  return featuredRank(a) - featuredRank(b)
    || (Number(a.price) || 0) - (Number(b.price) || 0)
    || String(a.name || "").localeCompare(String(b.name || ""));
}

// Brands recognised at the START of a product name when specs.Brand is empty
// (e.g. "Havells 32A MCB", "WAAREE 550Wp ..."). Generic BOS items stay unbranded.
const KNOWN_BRANDS = ["Deye", "Gronsol", "Polycab", "Solis", "Luminous", "Glannu", "Havells", "SIBASS",
  "Elmex", "Chint", "Kenbrook", "Waaree", "Microtek", "Worldsun", "Shelter"];
const ALIASES = { "solis (ginlong)": "Solis", "ginlong": "Solis" };

function canonBrand(b) {
  const s = String(b == null ? "" : b).trim();
  if (!s) return "";
  const low = s.toLowerCase();
  if (ALIASES[low]) return ALIASES[low];
  return KNOWN_BRANDS.find((k) => k.toLowerCase() === low) || s;
}

function brandOf(p) {
  const spec = p && p.specs && p.specs.Brand;
  if (spec && String(spec).trim()) return canonBrand(spec);
  const name = String((p && p.name) || "").trim().toLowerCase();
  const hit = KNOWN_BRANDS.find((k) => name === k.toLowerCase() || name.startsWith(k.toLowerCase() + " "));
  return hit || "";
}

module.exports = { CATEGORY_RANK, featuredRank, featuredCompare, KNOWN_BRANDS, canonBrand, brandOf };
